import React, { useEffect, useState } from "react";
import { FormControl, InputGroup } from "react-bootstrap";
import { useValidateDiscount } from "./store";
import { Button, Select, Switch, Tooltip } from "antd";
import { isEmpty } from "lodash";
import { currentUser, ROLES_NAME } from 'modules/utilities/utility';
import { CloseCircleOutlined } from '@ant-design/icons';

const {SUPER_ADMIN, LEAD_AGENT, CLINIC_RECEPTIONIST, IVR, CHAT} = ROLES_NAME;
function LeadDiscount({
  setDiscountValue,
  setIsCustomDiscount,
  setSelectedDiscount,
  totalPrice,
  discountCode,
  setDiscountCode,
  subFlag,
  setSubFlag,
}) {
  const { postDisData, getDiscountData, disCode } = useValidateDiscount();
  const [orgDisData, setOrgDisData] = useState(null);

  useEffect(() => {
    getDiscountData();
  }, []);


  useEffect(() => {
    if (subFlag && discountCode?.length) {
      postDisData(
        {
          discount_code: discountCode,
          total_amount: totalPrice,
        },
        setOrgDisData
      );
      setIsCustomDiscount(true);
    } else {
      setDiscountCode(null)
      setOrgDisData(null);
      setIsCustomDiscount(false);
    }
  }, [subFlag]);

  useEffect(() => {
    if (!isEmpty(orgDisData)) {
      if (orgDisData?.isValidDiscountCode) {
        setSelectedDiscount({
          code: discountCode,
          amount: orgDisData?.discountValue,
          type: orgDisData?.discountType,
          label: `Custom ${discountCode} ${
            orgDisData?.discountType === "percentage" ? "%" : "₹"
          }`,
        });
        setDiscountValue(orgDisData?.discountValue);
      } else {
        setSelectedDiscount(null);
        setDiscountValue(0);
      }
    }
  }, [orgDisData]);

  const handleSubmit = () => {
    setSubFlag(subFlag + 1);
  };
  
  return (
    <div>
      <div className="my-2 d-flex flex-row gap-3">
        <div className="fw-bold"> Custom Discount : </div>
        <Switch
          onChange={(toggle) => {
            setSubFlag(toggle);
            if (toggle === false) {
              setSelectedDiscount(null);
            }
          }}
        />
      </div>
      {subFlag ? (
        <div className="d-flex flex-column">
          <RenderDiscountComponent discountCode={discountCode} setDiscountCode={setDiscountCode} disCode={disCode} handleSubmit={handleSubmit}/>
          {!orgDisData?.isValidDiscountCode ? (
            <div className="mt-2 fw-bold text-danger">
              {orgDisData?.error || ""}
            </div>
          ) : null}
        </div>
      ) : null}
    </div>
  );
}

export default LeadDiscount;

const RenderDiscountComponent = ({ discountCode, setDiscountCode, disCode, handleSubmit}) => {
  switch(currentUser){
    case LEAD_AGENT: 
    case CLINIC_RECEPTIONIST: 
    case SUPER_ADMIN:
    case IVR: return <SelectDiscount discountCode={discountCode} setDiscountCode={setDiscountCode} disCode={disCode['telesales']} handleSubmit={handleSubmit} />
    case CHAT: return <SelectDiscount discountCode={discountCode} setDiscountCode={setDiscountCode} disCode={disCode['chat']} handleSubmit={handleSubmit} />
  }
}
const InputDiscount = ({setDiscountCode, handleSubmit}) => {
	return (
		<InputGroup className='mb-3'>
			<InputGroup.Text id='inputGroup-sizing-default'>
				Discount Code
			</InputGroup.Text>
			<FormControl
				aria-label='Enter discount code'
				aria-describedby='inputGroup-sizing-default'
				onChange={e => setDiscountCode(e.target.value)}
			/>
			<button
				className='btn btn-primary'
				onClick={handleSubmit}>
				Submit
			</button>
		</InputGroup>
	);
};

const SelectDiscount = ({discountCode, setDiscountCode, disCode, handleSubmit}) => {
  const codes = disCode ? disCode.map(code => ({label: code, value: code})) : [];
  const options = [...codes, {label: 'Other', value: 'other'}]
  return discountCode === 'other' ? 
  <div className='d-flex gap-2'>
    <InputDiscount setDiscountCode={setDiscountCode} handleSubmit={handleSubmit}/> 
    <Tooltip title="Remove input">
          <Button icon={<CloseCircleOutlined />} danger onClick={() => setDiscountCode(null)} />
    </Tooltip>
  </div>: 
  <div className='d-flex flex-row w-75'>
			<div className='flex-3'>
				<Select
					id='discountCode'
					value={discountCode}
					onChange={value => setDiscountCode(value)}
					style={{ width: '100%' }}>
					{options.map(item => <Option key={item.value} value={item.value}>{item.label}</Option>)}
				</Select>
			</div>
			<button
				className='btn btn-primary flex-1'
				onClick={handleSubmit}>
				Submit
			</button>
		</div>
	
};
